import { render, staticRenderFns } from "./Serial.vue?vue&type=template&id=1de1fdfa"
import script from "./Serial.vue?vue&type=script&lang=js"
export * from "./Serial.vue?vue&type=script&lang=js"
import style0 from "./Serial.vue?vue&type=style&index=0&id=1de1fdfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports